"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ServiceLocation = _interopRequireDefault(require("../ServiceLocation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingLocation = function BookingLocation(_ref) {
  var booking = _ref.booking,
      i18n = _ref.i18n,
      onLocationUrlMount = _ref.onLocationUrlMount,
      onLocationUrlClick = _ref.onLocationUrlClick;
  var service = booking.service;
  return /*#__PURE__*/_react["default"].createElement(_ServiceLocation["default"], {
    isServiceBooked: true,
    locationType: service.location_type,
    formattedAddress: booking.location.formatted_address.address_lines,
    customLocationText: service.custom_location_text,
    locationUrl: booking.location_url,
    locationUrlNotes: service.location_url_notes,
    i18n: {
      nullTeleconferenceUrl: i18n.nullTeleconferenceUrl
    },
    onLocationUrlMount: onLocationUrlMount,
    onLocationUrlClick: onLocationUrlClick
  });
};

BookingLocation.propTypes = {
  booking: _propTypes["default"].shape({
    location_url: _propTypes["default"].string,
    service: _propTypes["default"].shape({
      location_type: _propTypes["default"].string.isRequired,
      custom_location_text: _propTypes["default"].string,
      location_url_notes: _propTypes["default"].string
    }),
    location: _propTypes["default"].object
  }).isRequired,
  i18n: _propTypes["default"].shape({
    nullTeleconferenceUrl: _propTypes["default"].string.isRequired
  }).isRequired,
  onLocationUrlMount: _propTypes["default"].func,
  onLocationUrlClick: _propTypes["default"].func
};
var _default = BookingLocation;
exports["default"] = _default;